import { faBullhorn } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { CampaignClass, EIntegrationTypes } from '@feathr/blackbox';
import { Button, FeatureCard } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';

interface IMetaCreateCampaignCardProps {
  disabled?: boolean;
}

function MetaCreateCampaignCard({ disabled }: Readonly<IMetaCreateCampaignCardProps>): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  const localUrl = useLocalUrl();

  function handleClick(): void {
    history.push(localUrl('/marketing/all'), {
      campaignClasses: [CampaignClass.Omni],
      overrides: { integrations: [EIntegrationTypes.Facebook] },
    });
  }

  return (
    <FeatureCard
      action={
        <Button
          disabled={disabled}
          name={'create-campaign-button'}
          onClick={handleClick}
          tooltip={
            disabled &&
            t(
              'Once we finish setting up your Meta integration, you will be able to create campaigns.',
            )
          }
          tooltipPosition={'bottom'}
        >
          {t('Create campaign')}
        </Button>
      }
      dropShadow={true}
      icon={faBullhorn}
      iconDropShadow={true}
      iconTheme={'cyan'}
      label={t('Create new campaign')}
      name={'meta-create-campaign-card'}
    >
      {t('Launch a new Pixl Plus campaign to target audiences on Meta')}
    </FeatureCard>
  );
}

export default MetaCreateCampaignCard;
